import { eventDataFilterParamsAtom } from '@/atoms/queries/eventData';
import { TopBar } from '@/components/topBar/TopBar';
import { TopBarHeading } from '@/components/topBar/TopBarHeading';
import { useAutoResetSelectionLayer } from '@/hooks/useAutoResetSelectionLayer';
import { useAtomValue } from 'jotai';
import { ScopeProvider } from 'jotai-scope';
import { Outlet } from 'react-router-dom';
import { layoutScopeAtoms } from '@/consts/scope';
import { playerAggsBaseFiltersAtom } from '@/atoms/queries/player/playerAggData';
import { useDataLockerTitle } from '@/hooks/useDataLockerTitle';
import { AppShellContents } from '../AppShell';
import { SectionWrapper } from '../SectionWrapper';

const DataLockerInner = () => {
  const filterParams = useAtomValue(eventDataFilterParamsAtom);
  useAutoResetSelectionLayer(filterParams);

  return (
    <SectionWrapper section="dataLocker">
      <Outlet />
    </SectionWrapper>
  );
};

export const DataLockerLayout = () => {
  const title = useDataLockerTitle();

  return (
    <ScopeProvider atoms={[...layoutScopeAtoms, playerAggsBaseFiltersAtom]}>
      <AppShellContents
        topBar={
          <TopBar>
            <TopBarHeading>{title}</TopBarHeading>
          </TopBar>
        }
      >
        <DataLockerInner />
      </AppShellContents>
    </ScopeProvider>
  );
};
